export default "__VITE_ASSET__d68f1957__"